import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Immutable from 'immutable'

import Button from 'components/Button'
import Dropdown from 'components/DropDown'
import Input from 'components/Input'
import Modal from 'components/Modal'
import Loading from 'components/Loading'
import DropDownSelectInputField from 'components/DropDownSelectInputField'

import Divider from 'elements/Divider'
import Label from 'elements/Label'
import Title from 'elements/Title'

import { validateEmail } from 'utils/strings'

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem 0 1rem 0;
`

const FormWrapper = styled.div`
  padding: 0 3rem 2rem 3rem;
`

const FormInput = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  /* padding-bottom: 1rem; */
`

const ModalButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2rem;
  padding-bottom: 1rem;
`

const roleOptions = Immutable.List([
  { label: 'Manager', value: 'manager' },
  { label: 'User', value: 'user' }
])

function InviteMemberModal ({
  groups,
  isManager = false,
  isOpen = false,
  isOwner = false,
  onCancel,
  onSave,
  session,
  invites
}) {
  const featureFlags = session.get('feature_flags') || session.get('whitelist')
  const group = session.get('group') || null

  const [emailAddress, setEmailAddress] = useState('')
  const [selectedGroup, setSelectedGroup] = useState(group)
  const [selectedRole, setSelectedRole] = useState('user')

  const valid = () => (validateEmail(emailAddress))

  const onModalClose = () => {
    onCancel()
    setEmailAddress('')
    setSelectedGroup(group)
    setSelectedRole('user')
  }

  const renderContent = () => {
    if (invites?.get('loading')) {
      return <Loading />
    }

    return (
      <FormWrapper>
        <FormInput>
          <Input
            autoFocus
            label='Email Address'
            description=''
            inputId='email'
            onValueChange={setEmailAddress}
            value={emailAddress}
          />
        </FormInput>

        {isOwner &&
          <FormInput>
            <Dropdown
              options={roleOptions}
              clearable={false}
              label='Role'
              description='Assign a role to your new teammate.  Managers have access to team-level permissions such as creating sequences as other users, assigning seats, inviting users, and viewing team reports.'
              value={selectedRole}
              onOptionChange={(option) => {
                setSelectedRole(option.value)
              }}
              mb='1rem'
            />
          </FormInput>}

        {featureFlags.includes('show_group_ui') &&
            (isOwner || isManager) &&
              <FormInput>
                <DropDownSelectInputField
                  options={groups}
                  clearable
                  label='Group'
                  customCreateLabel='Create new group...'
                  disabled={!!group}
                  description="Assign a group to your new teammate.  Users assigned a group are restricted to seeing only their own group's sequences and contacts"
                  value={selectedGroup}
                  onOptionChange={(option) => {
                    const newValue = option && option.value ? option.value : null
                    setSelectedGroup(newValue)
                  }}
                  mb='1rem'
                />
              </FormInput>}

      </FormWrapper>
    )
  }

  return (
    <Modal
      isOpen={isOpen}
      onModalClose={onModalClose}
    >
      <Wrapper>
        <Title align='center'>Add a Teammate</Title>
        <Label align='center' mt='0.5rem'>Invite more members to your team. Your teammate will receive an email with instructions to join your team.</Label>

        {renderContent()}

        <Divider />

        <ModalButtonContainer>
          <Button
            label='Cancel'
            handleClick={() => {
              onCancel()
              setEmailAddress('')
              setSelectedGroup(null)
              setSelectedRole('user')
            }}
            mr='0.5rem'
          />
          <Button
            primary
            label='Send Invite'
            disabled={!valid()}
            handleClick={() => {
              onSave(emailAddress, selectedRole, selectedGroup)
              setEmailAddress('')
              setSelectedGroup(null)
              setSelectedRole('user')
            }}
          />
        </ModalButtonContainer>

      </Wrapper>
    </Modal>
  )
}

InviteMemberModal.propTypes = {
  groups: PropTypes.instanceOf(Immutable.List),
  isManager: PropTypes.modal,
  isOwner: PropTypes.bool,
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  value: PropTypes.string,
  session: PropTypes.object,
  invites: PropTypes.object
}

export default InviteMemberModal
